import React from "react"

const DayBadge = ({ nights, t }) => {
  return (
    <div className="flex items-center z-30 absolute top-1/2 overflow-hidden -left-5 -translate-y-1/2">
      <svg width="20" height="40" viewBox="0 0 40 80" className="text-second-success flex-shrink-0">
        <path d="M 40 0 L 0 40 L 40 80 Z" fill="currentColor" />
      </svg>

      <div className="bg-second-success rounded-tr-md rounded-br-md h-10 px-3 flex items-center">
        <span className="text-[15px] font-bold text-white whitespace-nowrap">
          {nights} {t("admin.nights_lower")}
        </span>
      </div>
    </div>
  )
}

export default DayBadge
